import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {from} from 'rxjs';
import {Injectable} from '@angular/core';
import {AuthService} from '../service';
import {Router} from '@angular/router';
import { AuthNewService } from '../service/auth-new.service';
import { fetchAuthSession } from 'aws-amplify/auth'


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private router: Router,
                private authService: AuthNewService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return from(this.getAuth(req, next));
    }

    async getAuth(req: HttpRequest<any>, next: HttpHandler) {
      const session = await fetchAuthSession();
      req = req.clone({headers: req.headers.append('Authorization', session.tokens.idToken?.toString())});
      return next.handle(req).toPromise();
    }
}
